import React, { useState } from 'react'
import { LoadScript } from '@react-google-maps/api'

import { Header } from 'src/components/common/TitleSection'
import { Location } from './Location'
import { ContactForm } from './ContactForm'
import { CustomModal } from 'src/components/common/Modal/CustomModal'
import ChildrenModal from 'src/components/common/ChildrenModal'
import Congratulations from 'src/assets/logos/congratulations.avif'
import Error from 'src/assets/logos/error.avif'
import headerBookACall from 'src/assets/BookACall/ImageToStl.com_khgdr.avif'
import { useTranslations } from 'src/provider/LocaleProvider'
export const BookACall = () => {
    const t = useTranslations()
    const [congratulations, setCongratulations] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)
    const [emailError, setEmailError] = useState<boolean>(false)
    const handleCongratulations = () => {
        setCongratulations(!congratulations)
    }
    const handleError = () => {
        setError(!error)
    }
    const handleEmailError = () => {
        setEmailError(!emailError)
    }
    return (
        <>
            {congratulations && (
                <CustomModal
                    handleClose={handleCongratulations}
                    content={
                        <ChildrenModal
                            handleClose={handleCongratulations}
                            image={Congratulations}
                            title={t('bookACall.modal.title')}
                            content={t('bookACall.modal.content')}
                            button={t('cta.close')}
                            double={true}
                        />
                    }
                />
            )}
            {error && (
                <CustomModal
                    handleClose={handleError}
                    content={
                        <ChildrenModal
                            handleClose={handleError}
                            image={Error}
                            title={t('bookACall.error.title')}
                            content={t('bookACall.error.content')}
                            button={t('cta.close')}
                            contact={'Support'}
                            double={false}
                        />
                    }
                />
            )}
            {emailError && (
                <CustomModal
                    handleClose={handleEmailError}
                    content={
                        <ChildrenModal
                            handleClose={handleEmailError}
                            image={Error}
                            title={t('bookACall.error.ops')}
                            content={t('bookACall.error.email')}
                            button={t('cta.close')}
                            contact={'Support'}
                            double={false}
                        />
                    }
                />
            )}
            <Header
                title={t('cta.bookACall')}
                subTitle={t('bookACall.subTitle')}
                image={headerBookACall}
            />
            <ContactForm
                setCongratulations={handleCongratulations}
                setError={handleError}
                setEmailError={handleEmailError}
            />
            <LoadScript googleMapsApiKey="AIzaSyDcSGQ7vOGMtjklG1MBVsY4PvG_Gk0w5js">
                <Location />
            </LoadScript>
        </>
    )
}
